module.exports = __webpack_public_path__ + "img/email.8585a8f7.svg";